import React from 'react'
import { arrayOf, func, number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useAtSize } from '@fs/zion-ui'
import NameMeaning from './NameMeaning'
import ComparisonPanel from '../ComparisonPanel/ComparisonPanel'
import { useDSCState } from '../../../../../state/DSCStore'
import { useAamState } from '../../../state/AamStore'
import { getGender } from '../../../../../shared/helpers/person_Helper'
import { useComparisonByName } from '../../../hooks/hooks'

export default function NameMeaningComparison({
  region,
  id,
  parsedNames,
  comparisonParsedNames,
  nameArgs,
  comparisonTargetNameArgs,
  comparisonTargetPerson,
  tileContentData,
  tileContentDispatch,
  tileComparisonContent,
  tileComparisonContentDispatch,
  tileData,
}) {
  const atSize = useAtSize()
  const dscState = useDSCState()
  const aamState = useAamState()
  const showComparison = useComparisonByName(
    aamState,
    comparisonTargetPerson,
    dscState,
    tileData,
    parsedNames,
    comparisonParsedNames
  )

  const containerStyle = css`
    display: flex;
    justify-content: center;
    align-items: top;
    width: 100%;
    flex-direction: ${atSize({ default: 'column-reverse', md: 'row' })};
  `

  return (
    <>
      <div css={containerStyle}>
        <ComparisonPanel gender={tileData?.gender?.toLowerCase()}>
          <NameMeaning
            region={region}
            id={id}
            parsedNames={parsedNames}
            nameArgs={nameArgs}
            tileContentData={tileContentData}
            tileContentDispatch={tileContentDispatch}
            styling={{ padding: '10px', width: '100%' }}
          />
        </ComparisonPanel>
        {showComparison && (
          <>
            <ComparisonPanel
              gender={
                comparisonTargetPerson?.gender
                  ? comparisonTargetPerson?.gender.toLowerCase()
                  : getGender(comparisonTargetPerson?.genderType)
              }
            >
              <NameMeaning
                region={region}
                id={id}
                parsedNames={comparisonParsedNames}
                nameArgs={comparisonTargetNameArgs}
                tileContentData={tileComparisonContent}
                tileContentDispatch={tileComparisonContentDispatch}
                styling={atSize({
                  default: { padding: '10px', width: '100%' },
                })}
              />
            </ComparisonPanel>
          </>
        )}
      </div>
    </>
  )
}

NameMeaningComparison.propTypes = {
  region: string,
  id: number,
  parsedNames: shape({
    firstName: shape({}),
    lastName: shape({}),
    middleNames: arrayOf(shape({ name: string })),
  }),
  tileContentData: shape({
    superType: string,
    meaning: string,
    name: string,
    head: string,
    add: string,
    typ: string,
    yr: number,
    reg: string,
    lang: string,
    cat: string,
    catid: number,
    scat: string,
  }),
  tileContentDispatch: func,
  tileData: shape({
    gender: string,
  }),
}
